import { render, staticRenderFns } from "./MainCalendarGroupEdit.vue?vue&type=template&id=50e2b9a0&scoped=true&"
import script from "./MainCalendarGroupEdit.vue?vue&type=script&lang=js&"
export * from "./MainCalendarGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2b9a0",
  null
  
)

export default component.exports